(function() {
    angular
        .module("globalSearchModule", [
            "ui.router"
        ])
})()
